import {
  PRODUCT_FLAG_ROWS,
  type ProductFlagTier,
  TIER_RANK,
} from '@/definitions/productFlags'

const countThrough = (tier: ProductFlagTier): number =>
  PRODUCT_FLAG_ROWS.filter((row) => TIER_RANK[row.tier] <= TIER_RANK[tier]).length

/**
 * How many product flags each package covers, counting everything it includes.
 *
 * Packages are cumulative, so Premium's number covers the Core product flags too, and
 * the manual switches are in every count because every organization has them. The
 * highest package therefore reports the full catalogue.
 */
export const PRODUCT_FLAG_COUNTS_BY_TIER = {
  manual: countThrough('manual'),
  core: countThrough('core'),
  premium: countThrough('premium'),
  copilot: countThrough('copilot'),
} as const satisfies Record<ProductFlagTier, number>
